// =============================================================================
// PROJECT FORM - CONSTANTS & CONFIGURATION
// =============================================================================
/**
 * Constants and configuration for ProjectForm component
 * @module ProjectForm.constants
 */

// Initial form state for new projects
export const INITIAL_FORM_STATE = {
    project_name: '',
    client_id: '',
    crew_number: '',
    country: ''
};

// Default status for new projects
export const DEFAULT_PROJECT_STATUS = 'pending_budget';

// Validation messages
export const VALIDATION_MESSAGES = {
    REQUIRED_FIELDS: 'Project Name, Client, Country, and Crew No. are required fields.'
};

// Form labels and placeholders
export const FORM_CONFIG = {
    projectName: {
        label: 'Project Name',
        placeholder: 'Enter project name',
        required: true
    },
    country: {
        label: 'Country',
        placeholder: 'Select a country',
        required: true
    },
    client: {
        label: 'Client',
        placeholder: 'Select a client',
        required: true
    },
    crewNumber: {
        label: 'Crew No.',
        placeholder: '00',
        required: true,
        maxDigits: 2
    }
};

// Modal titles
export const MODAL_TITLES = {
    CREATE: 'Create New Project',
    EDIT: 'Edit Project'
};

// Button labels
export const BUTTON_LABELS = {
    CLOSE: 'Close',
    SAVE: 'Save Changes'
};
